/**
 * MiniMax 开放平台 OpenAI 兼容文本对话（Bearer API Key，无需 GroupId）
 * @see https://platform.minimaxi.com/docs/api-reference/text-chat-openai
 */

export const MINIMAX_OPENAI_CHAT_COMPLETIONS =
  'https://api.minimaxi.com/v1/chat/completions';

/**
 * @param {string} [baseUrl] 用户配置的根地址（如 https://api.minimaxi.com/v1）或历史遗留完整路径
 * @returns {string} POST 用的完整 chat/completions URL
 */
export function resolveMinimaxChatCompletionUrl(baseUrl) {
  const raw = String(baseUrl ?? '').trim().replace(/\/+$/, '');
  if (!raw) return MINIMAX_OPENAI_CHAT_COMPLETIONS;

  if (/\/chat\/completions$/i.test(raw)) return raw;

  if (/chatcompletion_v2/i.test(raw) || /api\.minimax\.chat/i.test(raw)) {
    return MINIMAX_OPENAI_CHAT_COMPLETIONS;
  }

  if (/\/v1$/i.test(raw)) return `${raw}/chat/completions`;

  if (/^https?:\/\/api\.minimaxi\.com$/i.test(raw)) {
    return `${raw}/v1/chat/completions`;
  }

  return `${raw}/chat/completions`;
}
